import script from "./third-party-buy.vue?vue&type=script&lang=ts&setup=true"
export * from "./third-party-buy.vue?vue&type=script&lang=ts&setup=true"

import "./third-party-buy.vue?vue&type=style&index=0&id=e657cf2a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e657cf2a"]])

export default __exports__